<ng-template #ticker let-content="content">
  <div [ngStyle]="{ color: content.color, background: content.background, borderRadius: widgetBorderRadius }" class="message"
       [ngClass]="{ overflow: isOverflowing() }" id="message">
    <div class="header">
      <span [innerHTML]="content.title || '&nbsp;'"></span>
      <span [innerHTML]="content.subtitle || '&nbsp;'" class="subtitle"></span>
    </div>
    <div class="content-container" id="important-news-message">
      <img *ngIf="content.image" [src]="content.image?.URL" class="content-image"/>
      <div [innerHTML]="content.text" class="text" [style.height]="calcHeight()"></div>
    </div>
    <div class="icons" *ngIf="isOverflowing()">
      <ibex-icon name="angle-up-two" variant="blank"></ibex-icon>
      <ibex-icon name="angle-down-two" variant="blank"></ibex-icon>
    </div>
  </div>
</ng-template>

<div class="preview-dialog">
  <div class="preview-dialog-header">
    <h2 matDialogTitle>{{ 'preview.title' | translate }}</h2>
    <ibex-icon name="close" variant="blank" matDialogClose></ibex-icon>
  </div>
  <div class="project-list">
    <div (click)="selectProject(proj)" class="project" *ngFor="let proj of projects"
         [ngClass]="{active: selectedProject === proj}">{{ proj }}
    </div>
  </div>
  <div *ngIf="content" class="preview-container"
       [ngClass]="{'ibexsmart-background': selectedProject === 'ibexsmart' && !package?.ibexApp?.isLightDesign}">
    <div class="spinner-container" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>
    <div class="blur-background" *ngIf="!disableBlurInApp"></div>
    <div class="preview" appScale [scale]="scale" [ngClass]="{ibextablet: selectedProject === 'ibextablet',
    ibexsmart: selectedProject === 'ibexsmart', 'text-white dark': selectedProject === 'ibexsmart' && !package?.ibexApp?.isLightDesign,
    ibextabletEvent: (selectedProject === 'ibextablet' && content.contentType === 'event'), widget: content.contentType === 'ticker',
    ibextouch: selectedProject === 'ibextouch', ibextouchEvent: (selectedProject === 'ibextouch' && content.contentType === 'event')}">
      <ng-container *ngIf="selectedProject === 'ibextouch'">
        <ng-container *ngIf="content.contentType === 'information'">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [item]="content" [hideTitle]="true"
                             [linkName]="package.linkName"></lib-ng-components>
        </ng-container>
        <div *ngIf="content.contentType === 'news'" class="news-detail">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [half]="true" [item]="content"
                             [setAnalytics]="true" [type]="'news'" [newsDateFormat]="content.dateFormat"
                             [linkName]="package.linkName"></lib-ng-components>
        </div>
        <ng-container *ngIf="content.contentType === 'restaurant'">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [item]="content" [setAnalytics]="true"
                             [linkName]="package.linkName"></lib-ng-components>
        </ng-container>
        <div *ngIf="content.contentType === 'opening-hours'" class="opening-hours-detail">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [half]="true" [item]="content" [setAnalytics]="true"
                             [linkName]="package.linkName"></lib-ng-components>
        </div>
        <ng-container *ngIf="content.contentType === 'event'">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [half]="textOnly"
                             [item]="content" [setAnalytics]="true" [linkName]="package.linkName"></lib-ng-components>
        </ng-container>
        <ng-container *ngIf="content.contentType === 'gallery'">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [item]="content" [hideTitle]="true"
                             [linkName]="package.linkName"></lib-ng-components>
        </ng-container>
        <div *ngIf="content.contentType === 'social-media'" class="social-media-detail">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [item]="content" [half]="true" [setAnalytics]="true"
                             [linkName]="package.linkName"></lib-ng-components>
        </div>
        <ng-container *ngIf="content.contentType === 'accommodation'">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [item]="content" [setAnalytics]="true"
                             [linkName]="package.linkName"></lib-ng-components>
        </ng-container>
        <div *ngIf="content.contentType === 'ticker'" class="ticker ibextouch">
          <ng-container *ngTemplateOutlet="ticker; context:{ content: content }"></ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedProject === 'ibextablet'">
        <ng-container *ngIf="content.contentType === 'information'">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [item]="content" [hideTitle]="true"
                             [linkName]="package.linkName"></lib-ng-components>
        </ng-container>
        <div *ngIf="content.contentType === 'news'" class="news-detail">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [half]="true" [item]="content"
                             [setAnalytics]="true" [type]="'news'" [newsDateFormat]="content.dateFormat"
                             [linkName]="package.linkName"></lib-ng-components>
        </div>
        <div *ngIf="content.contentType === 'restaurant'" class="restaurant-detail">
          <lib-ng-components [previewProject]="selectedProject" [page]="'restaurant'" [item]="content" [setAnalytics]="true"
                             [linkName]="package.linkName"></lib-ng-components>
        </div>
        <div *ngIf="content.contentType === 'opening-hours'" class="opening-hours-detail">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [half]="true" [item]="content" [setAnalytics]="true"
                             type="news" [linkName]="package.linkName"></lib-ng-components>
        </div>
        <ng-container *ngIf="content.contentType === 'event'">
          <lib-ng-components [previewProject]="selectedProject" [page]="'event'"
                             [half]="textOnly" [item]="content" [linkName]="package.linkName"></lib-ng-components>
        </ng-container>
        <ng-container *ngIf="content.contentType === 'gallery'">
          <lib-ng-components [previewProject]="selectedProject" [page]="'default'" [item]="content" [hideTitle]="true"
                             [linkName]="package.linkName"></lib-ng-components>
        </ng-container>
        <div *ngIf="content.contentType === 'social-media'" class="social-media-detail">
          <lib-ng-components [previewProject]="selectedProject" [page]="'social-media'" [item]="content"
                             [linkName]="package.linkName"></lib-ng-components>
        </div>
        <div *ngIf="content.contentType === 'accommodation'" class="restaurant-detail">
          <lib-ng-components [previewProject]="selectedProject" [page]="'restaurant'" [item]="content" [setAnalytics]="true"
                             [linkName]="package.linkName"></lib-ng-components>
        </div>
        <div *ngIf="content.contentType === 'ticker'" class="ticker ibextablet">
          <ng-container *ngTemplateOutlet="ticker; context:{ content: content }"></ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedProject === 'ibexsmart'">
        <lib-ng-components
          *ngIf="['restaurant', 'accommodation', 'information', 'news', 'event', 'gallery', 'opening-hours'].includes(content.contentType)"
          [previewProject]="selectedProject" [page]="content.contentType" [item]="content"
          [linkName]="package.linkName"></lib-ng-components>
        <div *ngIf="content.contentType === 'ticker'" class="ticker ibexsmart">
          <div class="message">
            <span [innerHTML]="content.title || content.subtiitle" class="subtitle"></span>
            <img *ngIf="content.image" [src]="content.image?.URL" class="content-image"/>
            <div [innerHTML]="content.text" class="text"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
